// extracted by mini-css-extract-plugin
module.exports = {"root":"Cards-module--root--2QY0_","desc":"Cards-module--desc--2999J","list":"Cards-module--list--1fQMy","item":"Cards-module--item--3P7e_"};